import React from "react";
import { Box, Typography } from "@material-ui/core";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import useCheckoutClassicStyles from "./checkoutClassicStyles";

// Social proof in the mobile sticky bar.
export default function TrustBadge() {
  const classes = useCheckoutClassicStyles();
  return (
    <Box className={classes.trustBadge}>
      <VerifiedUserIcon className={classes.trustIcon} />
      <Box>
        <Typography className={classes.trustHeading}>
          Trusted by <span className={classes.trustHighlight}>210K+</span>{" "}
          businesses
        </Typography>
        <Typography className={classes.trustSubheading}>
          Across <span className={classes.trustHighlight}>68</span> countries
        </Typography>
      </Box>
    </Box>
  );
}
